module.exports = __webpack_public_path__ + "static/media/_JAYMART.916344ae.jpg";